import { SplatMesh } from '@sparkjsdev/spark';
import { ENDPOINTS, MEASURE } from '../config.js';
import { applyTransform } from './transform.js';
import { createSplatSource } from './sceneSource.js';

/**
 * Gaussian Splatting のスキャン(.spz/.ply/.splat)を読み込んでシーンに追加する。
 * onProgress には 0〜1 の進捗（総バイト数が不明な場合は null）を渡す。
 */
export async function loadSplat(scene, property, { onProgress } = {}) {
  const url = ENDPOINTS.splat(property.splat);

  const mesh = new SplatMesh({
    url,
    raycastable: true,
    minRaycastOpacity: MEASURE.minRaycastOpacity,
    // 部屋全体のスキャンは数百万スプラットになるため LOD を有効化する
    lod: 'quality',
    onProgress: (event) => {
      if (typeof onProgress !== 'function') return;
      const ratio = event?.lengthComputable && event.total > 0 ? event.loaded / event.total : null;
      onProgress(ratio);
    },
  });

  applyTransform(mesh, property.transform);
  scene.add(mesh);

  try {
    await mesh.initialized;
  } catch (cause) {
    scene.remove(mesh);
    throw new Error(`スキャンデータの読み込みに失敗しました: ${url}`, { cause });
  }

  return createSplatSource(mesh);
}
